import Vue, { RenderContext, FunctionalComponentOptions } from 'vue';
import { Utils } from '../../helpers/utils';

export const AppListItem = <FunctionalComponentOptions> {
    functional: true,
    name: 'app-list-item',
    props: {
        item: {
            type: Object
        }
    },
    render(h, ctx) {
        return (
            h('div', { 
                class: ['app-item', ctx.data.staticClass],
                on: clickHandler(ctx)
            }, [
                h('div', { class: 'app-item-content' }, [
                    h('div', { class: 'app-item-icon' }, [
                        h('div', { class: 'app-icon-wrapper' }, [
                            h('img', { class: 'app-icon', attrs: { src: `/images/icons/${ctx.props.item.shortName}.svg` }})
                        ])
                    ]),
                    h('div', { class: 'app-item-info' }, [
                        h('h1', { class: 'title' }, ctx.props.item.name),
                        h('div', { class: 'platform' }, [
                            h('i', { class: Utils.iconPlatformClass('icon', ctx.props.item.platform)}),
                            h('span', { class: 'platform-name' }, ctx.props.item.platform)
                        ])
                    ]),
                    h('div', { class: 'app-item-action' }, [
                        h('i', { class: 'icon icon-chevron-right-16' })
                    ])
                ])
            ])
        )
    }
}

function clickHandler(ctx: RenderContext) {
    if (ctx.data.on && ctx.data.on.click) {
        return { click: ctx.data.on.click }
    }
    return null;
}